// extracted by mini-css-extract-plugin
export default {"wrapper":"PrimaryMenu_wrapper__ydwJO","compact":"PrimaryMenu_compact__7BzPy","subMenuItem":"PrimaryMenu_subMenuItem__7ZIiz"};